<template>
  <footer class="footer" :class="{ 'footer-dark-mode': darkMode }">
    <div class="footer-top">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4 mb-5 mb-lg-0">
            <div class="footer-brand d-flex align-items-center mb-4">
              <h3 class="logo mb-0">STEELINE</h3>
            </div>
            <p class="mb-4">Современное металлообрабатывающее предприятие полного цикла в Набережных Челнах. Высокоточное оборудование и профессиональные специалисты.</p>
            <div class="contact-info">
              <div class="contact-item">
                <i class="fas fa-map-marker-alt contact-icon"></i>
                <div>
                  <p class="mb-0">г. Набережные Челны, Промышленная ул., д. 27</p>
                </div>
              </div>
              <div class="contact-item">
                <i class="fas fa-phone-alt contact-icon"></i>
                <div>
                  <a href="tel:+79677700773" class="contact-link">+7 (967) 770-07-73</a>
                </div>
              </div>
              <div class="contact-item">
                <i class="fas fa-envelope contact-icon"></i>
                <div>
                  <a href="mailto:steeline2012@yandex.ru" class="contact-link">steeline2012@yandex.ru</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0">
            <h4 class="footer-title">Наши возможности</h4>
            <div class="row">
              <div class="col-sm-6">
                <ul class="footer-links">
                  <li>
                    <a href="/services#laser-cutting">
                      <i class="fas fa-chevron-right"></i> <span>Лазерная резка</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services#tube-cutting">
                      <i class="fas fa-chevron-right"></i> <span>Резка труб</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services#metal-bending">
                      <i class="fas fa-chevron-right"></i> <span>Гибка листов</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services#guillotine">
                      <i class="fas fa-chevron-right"></i> <span>Рубка металла</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-sm-6">
                <ul class="footer-links">
                  <li>
                    <a href="/services#welding">
                      <i class="fas fa-chevron-right"></i> <span>Сварка</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services#powder-coating">
                      <i class="fas fa-chevron-right"></i> <span>Покраска</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services#galvanizing">
                      <i class="fas fa-chevron-right"></i> <span>Цинкование</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services#enamel-painting">
                      <i class="fas fa-chevron-right"></i> <span>Эмалирование</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <h4 class="footer-title">Быстрые ссылки</h4>
            <div class="row">
              <div class="col-sm-6">
                <ul class="footer-links">
                  <li>
                    <a href="/">
                      <i class="fas fa-chevron-right"></i> <span>Главная</span>
                    </a>
                  </li>
                  <li>
                    <a href="/services">
                      <i class="fas fa-chevron-right"></i> <span>Возможности</span>
                    </a>
                  </li>
                  <li>
                    <a href="/equipment">
                      <i class="fas fa-chevron-right"></i> <span>Оборудование</span>
                    </a>
                  </li>
                  <li>
                    <a href="/products">
                      <i class="fas fa-chevron-right"></i> <span>Продукция</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-sm-6">
                <ul class="footer-links">
                  <li>
                    <a href="/contacts">
                      <i class="fas fa-chevron-right"></i> <span>Контакты</span>
                    </a>
                  </li>
                  <li>
                    <a href="/privacy">
                      <i class="fas fa-chevron-right"></i> <span>Политика</span>
                    </a>
                  </li>
                  <li>
                    <a href="/sitemap">
                      <i class="fas fa-chevron-right"></i> <span>Карта сайта</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <p class="copyright mb-0">&copy; 2025 STEELINE. Все права защищены.</p>
          </div>
          <div class="col-md-6">
            <ul class="social-links">
              <li><a href="#" class="social-icon"><i class="fab fa-vk"></i></a></li>
              <li><a href="#" class="social-icon"><i class="fab fa-telegram"></i></a></li>
              <li><a href="#" class="social-icon"><i class="fab fa-whatsapp"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    darkMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(to bottom, var(--primary-dark), #001f30);
  color: rgba(255, 255, 255, 0.75);
  position: relative;
  transition: background 0.4s ease, color 0.4s ease;
}

.footer * {
  transition: color 0.3s ease, background 0.3s ease, border-color 0.3s ease;
}

.footer-top {
  padding: 90px 0 60px;
}

.footer-bottom {
  background-color: rgba(0, 0, 0, 0.25);
  padding: 25px 0;
  position: relative;
}

.footer-brand {
  margin-bottom: 1.5rem;
}

.logo-container {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, var(--secondary-color), var(--secondary-light));
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(255, 107, 0, 0.2);
}

.logo-icon {
  color: white;
  font-weight: 700;
  font-size: 20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.logo {
  font-weight: 800;
  color: white;
  font-size: 1.4rem;
  letter-spacing: 1px;
}

.footer-title {
  color: white;
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 1.75rem;
  position: relative;
  padding-bottom: 12px;
}

.footer-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, var(--secondary-color), var(--secondary-light));
  border-radius: 2px;
}

.contact-info {
  margin-top: 2rem;
}

.contact-item {
  display: flex;
  margin-bottom: 1.25rem;
}

.contact-icon {
  color: var(--secondary-light);
  margin-right: 1rem;
  font-size: 1.25rem;
  width: 20px;
  transition: transform 0.3s ease;
}

.contact-item:hover .contact-icon {
  transform: translateY(-2px);
}

.contact-link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

.contact-link:hover {
  color: var(--secondary-light);
  text-decoration: none;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 18px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
}

.footer-links a span {
  position: relative;
  transition: all 0.3s ease;
}

.footer-links a i {
  color: var(--secondary-color);
  margin-right: 10px;
  font-size: 0.75rem;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: white;
}

.footer-links a:hover i {
  transform: translateX(4px);
  color: var(--secondary-light);
}

.footer-links a:hover span {
  transform: translateX(2px);
}

.copyright {
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.7);
}

.social-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-end;
}

.social-links li {
  margin-left: 15px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1.1rem;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.social-icon:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--secondary-color), var(--secondary-light));
  opacity: 0;
  z-index: -1;
  transition: opacity 0.3s ease;
}

.social-icon:hover:before {
  opacity: 1;
}

.social-icon:hover {
  color: white;
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(255, 107, 0, 0.3);
}

@media (max-width: 991.98px) {
  .footer-top {
    padding: 70px 0 40px;
  }
}

@media (max-width: 767.98px) {
  .social-links {
    justify-content: center;
    margin-top: 1.25rem;
  }
  
  .social-links li:first-child {
    margin-left: 0;
  }
  
  .copyright {
    text-align: center;
    margin-bottom: 1rem;
  }
}

/* Dark Mode Styles for Services Page */
.footer.footer-dark-mode {
  background: linear-gradient(180deg, #060d18 0%, #0a0d1a 100%) !important;
  color: rgba(255, 255, 255, 0.85) !important;
}

.footer.footer-dark-mode .footer-top {
  background: transparent !important;
  border-top: 1px solid rgba(25, 118, 178, 0.2) !important;
  padding: 90px 0 60px;
}

.footer.footer-dark-mode .footer-bottom {
  background: rgba(0, 0, 0, 0.3) !important;
  border-top: 1px solid rgba(25, 118, 178, 0.15) !important;
}

.footer.footer-dark-mode .footer-title {
  color: #fff !important;
}

.footer.footer-dark-mode .footer-title::after {
  background: linear-gradient(90deg, #1976b2, transparent) !important;
}

.footer.footer-dark-mode p,
.footer.footer-dark-mode .copyright {
  color: rgba(255, 255, 255, 0.7) !important;
}

.footer.footer-dark-mode .logo {
  color: #fff !important;
}

.footer.footer-dark-mode .contact-icon {
  color: #1976b2 !important;
}

.footer.footer-dark-mode .contact-link {
  color: rgba(255, 255, 255, 0.85) !important;
}

.footer.footer-dark-mode .contact-link:hover {
  color: #1976b2 !important;
}

.footer.footer-dark-mode .footer-links a {
  color: rgba(255, 255, 255, 0.75) !important;
}

.footer.footer-dark-mode .footer-links a:hover {
  color: #fff !important;
}

.footer.footer-dark-mode .footer-links a i {
  color: #1976b2 !important;
}

.footer.footer-dark-mode .social-icon {
  background-color: rgba(25, 118, 178, 0.1) !important;
  border: 1px solid rgba(25, 118, 178, 0.2) !important;
}

.footer.footer-dark-mode .social-icon:hover {
  background-color: rgba(25, 118, 178, 0.2) !important;
  border-color: #1976b2 !important;
  box-shadow: 0 5px 15px rgba(25, 118, 178, 0.3) !important;
}

.footer.footer-dark-mode .social-icon:before {
  background: linear-gradient(135deg, #1976b2, #42a5f5) !important;
}
</style>
